import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "head-rows" }
const _hoisted_2 = { class: "head-menu" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "head-dialog-box" }
const _hoisted_9 = ["innerHTML"]

import { ref,reactive } from 'vue';
import logoSrc from '@/assets/image/logoIcon.webp';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'commonHeader',
  props: {
  data: String
},
  setup(__props) {

const store = useStore();
const router = useRouter();
const { locale } = useI18n();

const toggleLang = () => {
  locale.value = locale.value === 'zh' ? 'zh' : 'zh';
  // Optionally save preference
  localStorage.setItem('user_locale', locale.value);
};
const toggleLang2 = () => {
  // 俄语 <-> 中文 之间切换
  locale.value = locale.value === 'en' ? 'en' : 'en';
  // Optionally save preference
  localStorage.setItem('user_locale', locale.value);
};
const toggleLang3 = () => {
  // 俄语 <-> 中文 之间切换
  locale.value = locale.value === 'ru' ? 'ru' : 'ru';
  // Optionally save preference
  localStorage.setItem('user_locale', locale.value);
};



const handleSelect = (key: string, keyPath: string[]) => {
  store.commit('setNavIndex',key)
  console.log(key, keyPath);
  console.log(store.commit('setNavIndex',key));
};
const isActive = ref(localStorage.getItem('navIndex') || 0);
const gotoPage = (url:string,index:number) => {
  console.log('gotoPage:',url,index);
  isActive.value = index;
  router.push(url)
}
const activeName=ref('first');
const handleClick = (tab: any, event: Event) => {
  console.log('hahah',tab.props.name, event);
  router.push({path:'/about',query:{name:tab.props.name}})
}
const isAbout = ref('');
const activeName2 = ref('one');
const activeList = reactive([
    {
        index: 0,
        titleKey: 'products.product_1',
        name: 'one'
    }, {
        index: 1,
        titleKey: 'products.product_2',
        name: 'two'
    }, {
        index: 2,
        titleKey: 'products.product_3',
        name: 'three'
    }, {
        index: 3,
        titleKey: 'products.product_4',
        name: 'four'
    }
])
const handleClick2 = (tab: any, event: Event) => {
  console.log(tab, event,activeName2.value);
  router.push({path:'/breeze',query:{name:tab.props.name}})
};

const timer = ref(null);
const isVisible = ref(true);
const handleMouseEnter = (event: any) => {
  if(event){
    console.log('Mouse moved over tab', event,isVisible);
    if(event == 'about'){
      isAbout.value = 'about';
    }
    if(event == 'breeze'){
      isAbout.value = 'breeze';
    }
  } else {
    console.log(' tab', event,isVisible);
  }
  isVisible.value = true;
  // 在这里添加你的逻辑，比如改变样式等。
};
const handleMouseEnter2 = (event: any) => {
  console.log('......buxuyaoyincan',timer)
  isVisible.value = true;
  // 在这里添加你的逻辑，比如改变样式等。
};    


const handleMouseLeave = () => {
    isVisible.value = false;
  // 在这里添加你的逻辑，比如改变样式等。
}


// eslint-disable-next-line no-undef
const props = __props
console.log('props:',props)


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"width":"100%","height":"99px"} }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, {
        class: "head-row-bg",
        justify: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 6,
            class: "text-align",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoPage('/',0)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_image, {
                class: "head-logo",
                alt: "Vue logo",
                src: _unref(logoSrc),
                fit: "contain"
              }, null, 8, ["src"]),
              _cache[8] || (_cache[8] = _createElementVNode("p", { class: "logo-title" }, "LIFSONG", -1))
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 18,
            class: "head-menus"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: _normalizeClass(isActive.value == 0?'head-menu-item head-menu-item-active':'head-menu-item'),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (gotoPage('/',0)))
                }, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('header.home')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(isActive.value == 1?'head-menu-item head-menu-item-active':'head-menu-item'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (gotoPage('/hhb',1)))
                }, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('header.vitalqi_series')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(isActive.value == 1?'head-menu-item head-menu-item-active':'head-menu-item'),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (gotoPage('/mms',4)))
                }, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('mms.title')), 1)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(isActive.value == 2?'head-menu-item head-menu-item-active':'head-menu-item'),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (gotoPage('/breeze',2))),
                  onMouseenter: _cache[5] || (_cache[5] = ($event: any) => (handleMouseEnter('breeze')))
                }, [
                  _createElementVNode("div", {
                    class: "title",
                    innerHTML: _ctx.$t('header.breeze_series')
                  }, null, 8, _hoisted_6)
                ], 34),
                _createElementVNode("div", {
                  class: _normalizeClass(isActive.value == 3?'head-menu-item head-menu-item-active':'head-menu-item'),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (gotoPage('/about',3))),
                  onMouseenter: _cache[7] || (_cache[7] = ($event: any) => (handleMouseEnter('about')))
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('header.about_us')), 1)
                ], 34),
                (_unref(locale) !== 'zh')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "head-menu-item lang-switch",
                      onClick: toggleLang
                    }, [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("div", {
                        class: "title",
                        style: {"border":"1px solid #fff","padding":"5px 10px","border-radius":"4px"}
                      }, " 中文 ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_unref(locale) !== 'en')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "head-menu-item lang-switch",
                      onClick: toggleLang2
                    }, [...(_cache[10] || (_cache[10] = [
                      _createElementVNode("div", {
                        class: "title",
                        style: {"border":"1px solid #fff","padding":"5px 10px","border-radius":"4px","margin-left":"10px"}
                      }, " EN ", -1)
                    ]))]))
                  : _createCommentVNode("", true),
                (_unref(locale) !== 'ru')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: "head-menu-item lang-switch",
                      onClick: toggleLang3
                    }, [...(_cache[11] || (_cache[11] = [
                      _createElementVNode("div", {
                        class: "title",
                        style: {"border":"1px solid #fff","padding":"5px 10px","border-radius":"4px","margin-left":"10px"}
                      }, " RU ", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (isVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "head-dialog",
            onMouseenter: handleMouseEnter2,
            onMouseleave: handleMouseLeave
          }, [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      (isAbout.value == 'about')
                        ? (_openBlock(), _createBlock(_component_el_tabs, {
                            key: 0,
                            class: "head-tabs",
                            onTabClick: handleClick
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_tab_pane, {
                                class: "head-tabs-item",
                                label: _ctx.$t('header.vision'),
                                name: "first"
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_tab_pane, {
                                class: "head-tabs-item",
                                label: _ctx.$t('header.history'),
                                name: "second"
                              }, null, 8, ["label"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (isAbout.value== 'breeze')
                        ? (_openBlock(), _createBlock(_component_el_tabs, {
                            key: 1,
                            class: "head-tabs",
                            onTabClick: handleClick2
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeList, (item, index) => {
                                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                  class: "head-tabs-item",
                                  name: item.name,
                                  key: index
                                }, {
                                  label: _withCtx(() => [
                                    _createElementVNode("span", {
                                      innerHTML: _ctx.$t(item.titleKey)
                                    }, null, 8, _hoisted_9)
                                  ]),
                                  _: 2
                                }, 1032, ["name"]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 32))
        : _createCommentVNode("", true),
      _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"width":"100%","height":"99px"} }, null, -1))
    ])
  ]))
}
}

})